import { useController, useFormContext } from "react-hook-form";
import { AsyncSelectField } from "../fields/AsyncSelectField";
import { AsyncProps } from "react-select/async";

type OwnProps = {
  label?: string;
  helperText?: string;
  name: string;
  onChange?: (value: any) => void;
  retrieveAsyncOptions: (
    inputValue: string
  ) => Promise<
    {
      label: string;
      value: string | number;
    }[]
  >;
} & AsyncProps<any, any, any>;

export const AsyncSelectInput = ({
  name,
  onChange,
  loadOptions,
  options,
  retrieveAsyncOptions,
  ...rest
}: OwnProps) => {
  const { control, formState, getFieldState } = useFormContext();

  const {
    field: { ref, value, onChange: controllerOnChange, ...controllerRest },
  } = useController({
    name: name as string,
    control,
  });

  return (
    <AsyncSelectField
      innerRef={ref}
      errorMessage={getFieldState(name as string, formState).error?.message}
      onChange={(value) => {
        const newValue = value as { value: string | number; label: string };
        controllerOnChange(newValue.value);
        if (onChange) {
          onChange(newValue.value);
        }
      }}
      retrieveAsyncOptions={retrieveAsyncOptions}
      value={value}
      {...rest}
      {...controllerRest}
    />
  );
};
